module.exports = __webpack_public_path__ + "img/nobookcover.fbba358f.png";